import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ColorPaletteService {
  private colorChangeSubject = new BehaviorSubject<string>('#faf5c8');
  colorChange$ = this.colorChangeSubject.asObservable();

  changeColor(color: string) {
    this.colorChangeSubject.next(color);
  }
}
